
import ThreatGuardIcon from "../../assets/sidebarAssets/ThreatGuardIcon";
import IntelligenceReportsIcon from "../../assets/sidebarAssets/IntelligenceReportsIcon";
import DemoEnvironmentIcon from "../../assets/sidebarAssets/DemoEnvironmentIcon";
import ReportIcon from "../../assets/admin-assets/ReportIcon";
import {canViewDemoPoint, canViewIntelligenceReports} from "../../../utils/rolePermissions";

const entry = (title = "", target = "/", icon = <ThreatGuardIcon/>, canView) => ({
  title,
  target,
  icon,
  canView,
});

export const entriesHomePage = {
  "home": [
    entry("DemoPoint", "/demo-point", <DemoEnvironmentIcon/>, canViewDemoPoint),
    entry("Intelligence Reports", "/intelligence-reports", <IntelligenceReportsIcon/>, canViewIntelligenceReports),
    // entry("ThreatGuard", "/threatguard", <ThreatGuardIcon/>)
  ],
  "admin": [
    entry("Demo Point Blueprints", "/admin/blueprints", <DemoEnvironmentIcon/>),
    entry("Reports", "/admin/reports", <ReportIcon/>),
  ],
  "reportsAdmin": [
    entry("Reports", "/admin/reports", <ReportIcon/>),
  ],
};
